<template>
    <div class="inquiry_main">
        <p class="current">当前位置：<span>报价</span></p>
        <div class="inquiry_info"> </div>
    </div>
</template>

<script>
export default{
    data(){
        return{
            
        }
    },
    methods: {

    },
    mounted(){
        
    }
}
</script>

<style scoped lang="scss">
.inquiry_main{
    background: #fff;
    width: 1190px;
    padding-bottom: 30px;
    min-height: calc(100vh - 215px);
    margin: 45px auto;
    position: relative;
    .current{
       
        position: absolute;
        top: 10px;
        left: 10px;
        font-size: 17px;
        color: #333;
        span{
            font-size: 17px;
            cursor: pointer;
            color: #666666;
        }
    }
    .inquiry_info{
        width: 1180px;
        margin: 25px auto;
        padding: 10px 0px;
        position: relative;
    }
}
</style>